/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    EditResearcherDataGenPool: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditResearcherDataGenPoolAction.REQUEST_EDITRESEARCHERDATAGENPOOL:
      return {
        ...state
      };
    case actions.EditResearcherDataGenPoolAction.EDITRESEARCHERDATAGENPOOL_RECEIVED:
      return {
        ...state,
        EditResearcherDataGenPool: action.data
      };

    default:
      return state;
  }
};

export default reducer;
